import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterSimplifiedTargetTextComponent } from './letter-simplified-target-text.component';

@NgModule({
  declarations: [LetterSimplifiedTargetTextComponent],
  imports: [
    CommonModule
  ],
  exports:[LetterSimplifiedTargetTextComponent],
})
export class LetterSimplifiedTargetTextModule { }
